import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


export interface AlertMessage {
  message: string;
  type: AlertType;
}

export type AlertType = 'success' | 'error' | 'warning' | 'info' | 'clear';


@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private alertSubject = new Subject<AlertMessage>();
  alertState$ = this.alertSubject.asObservable();
  private timeoutId: any;

  showAlert(message: string, type: AlertType) {
    this.clearAlert();
    this.alertSubject.next({ message, type });

    this.timeoutId = setTimeout(() => {
      this.clearAlert();
    }, 8000);
  }

  clearAlert() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.alertSubject.next({ message: '', type: 'clear' });
  }
}
